import styled from 'styled-components';

export const RoutesContainer = styled.div`
  flex-grow: 1;
  width: 100%;
`;
